import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'scaffold-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: false,
})
export class SearchBarComponent implements OnInit {
  @Output() search: EventEmitter<searchObject> = new EventEmitter();
  term: string = '';
  key: string = 'all';
  itemState: itemActiveStateFilter = itemActiveStateFilter.both;

  /*
  Search data will be object with two keys
    data: the key to be searched,
    label: the label to display in select list

*/
  itemActiveStateFilterEnum = itemActiveStateFilter;
  activeStateFilter = itemActiveStateFilter.both;
  @Input() allowSearch = false;
  @Input() searchData = [];
  @Input() perPageOptions = [{ count: 10 }, { count: 25 }, { count: 50 }];
  @Input() perPage: number = 10;
  @Input() showPaginate;
  @Input() hideTermSelect;
  @Input() forceOnlyActive = false;
  @Input() displayActiveStateFilter = false;
  @Input() searchPlaceholder = 'Search';
  @Input() activePlaceholder = 'Status:';
  public searchOptions = [{ data: '', label: 'All' }];
  public searchOptions3 = [
    { value: this.itemActiveStateFilterEnum.active, label: 'active' },
    { value: this.itemActiveStateFilterEnum.inactive, label: 'inactive' },
    { value: this.itemActiveStateFilterEnum.both, label: 'both' },
  ];
  constructor() {}

  ngOnInit() {
    //default the search key to the first item in the search data
    if (this.searchData?.length > 0) {
      this.searchOptions = [...this.searchData, ...this.searchOptions];
      this.key = this.searchData[0].data;
    }
  }

  changeSearchKey(item) {
    this.key = item?.data || 'all';
  }

  getActiveItemState() {
    return this.forceOnlyActive
      ? itemActiveStateFilter.active
      : this.displayActiveStateFilter
        ? this.activeStateFilter
        : itemActiveStateFilter.both;
  }

  initSearch(clear?: boolean) {
    let search: searchObject;
    if (clear) {
      this.term = null;
    }
    if (this.term && this.term.length > 0) {
      search = {
        key: this.hideTermSelect ? 'all' : this.key || 'all',
        term: this.term,
        itemState: this.getActiveItemState(),
      };
    } else {
      search = {
        key: null,
        term: null,
        itemState: this.getActiveItemState(),
      };
    }
    console.log(search);
    this.search.emit(search);
  }
}

export class searchObject {
  term: string;
  key: string;
  itemState: itemActiveStateFilter;
}

export enum itemActiveStateFilter {
  active = 'active',
  inactive = 'inactive',
  both = '',
}
